var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Chip, Divider, MenuItem, Typography, useMediaQuery } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { dashboardSearchFI, dashboardSearchSA, SearchAppointment, SearchEstimate, SearchInspection, SearchJobCard } from "../../../api/url";
import { RoundClearIcon } from "../../../assets/customIcons";
import { DocIcon, PhoneGrayIcon } from "../../../assets/images";
import { FormSearchSelect } from "../../../builderPackage/components/dynamicFormBuilder/components/formSearchSelect";
import { EModuleTypes, EUserRole, LOCAL_STORAGE_KEYS, ModuleName, SEARCH_TYPES_ENUM, StatusEnum } from "../../../constants";
import { getListAPI, resetState } from "../../../redux/crudSlice";
import { useAppDispatch } from "../../../store/hooks";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { MuiStack } from "../../atoms/stackComponent";
import { ESearchKeys } from "./entity";
import { getStatusColor } from "../../../theme/statusColors";
var DashboardSearch = function (props) {
    var _getLocalStorageItem, _getLocalStorageItem2;
    var moduleName = props.moduleName, _a = props.fullWidth, fullWidth = _a === void 0 ? true : _a;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _b = useState(""), searchValue = _b[0], setsearchValue = _b[1];
    var _c = useState([]), response = _c[0], setResponse = _c[1];
    var _d = useState(0), clearKey = _d[0], setClearKey = _d[1];
    var User = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.Branches[0];
    var UserIdentity = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.IdentityId;
    var role = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down('sm'); });
    useEffect(function () {
        dispatch(resetState(['preDocumentFetch']));
    }, []);
    var getURL = function () {
        if (moduleName !== ModuleName.Dashboard) {
            return catalogueSearchUrl();
        }
        else {
            if ((role === null || role === void 0 ? void 0 : role.Name) === EUserRole.FinalInspector) {
                return dashboardSearchFI;
            }
            else
                return dashboardSearchSA;
        }
    };
    var globalSearchAPICall = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var _request$search, _a, key, _b, request, _c, url, updatedRequest, _res$payload, _res$payload2, res;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!getURL())
                        return [2 /*return*/];
                    _a = params.key, key = _a === void 0 ? ESearchKeys.Response : _a, _b = params.request, request = _b === void 0 ? {} : _b, _c = params.url, url = _c === void 0 ? getURL() : _c;
                    updatedRequest = _objectSpread(_objectSpread(_objectSpread({}, request), props.request), {}, {
                        OrganizationId: User === null || User === void 0 ? void 0 : User.OrganizationId,
                        ParentOrganizationId: User === null || User === void 0 ? void 0 : User.ParentOrganizationId,
                        Type: (role === null || role === void 0 ? void 0 : role.Name) === EUserRole.FinalInspector ? SEARCH_TYPES_ENUM.FinalInspection : undefined
                        // IdentityId: moduleName === ModuleName.Dashboard && role?.Name === EUserRole.FinalInspector ? UserIdentity : undefined
                    });
                    setsearchValue(request === null || request === void 0 ? void 0 : request.search);
                    if (!((request === null || request === void 0 || (_request$search = request.search) === null || _request$search === void 0 ? void 0 : _request$search.length) > 2)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: key,
                            url: url,
                            request: updatedRequest
                        }))];
                case 1:
                    res = _d.sent();
                    setResponse(res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.value) === null || _res$payload === void 0 ? void 0 : _res$payload.data);
                    return [2 /*return*/, res === null || res === void 0 || (_res$payload2 = res.payload) === null || _res$payload2 === void 0 ? void 0 : _res$payload2.value];
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var catalogueSearchUrl = function () {
        var url;
        switch (moduleName) {
            case EModuleTypes.Appointment:
                url = SearchAppointment;
                break;
            case EModuleTypes.Inspection:
                url = SearchInspection;
                break;
            case EModuleTypes.ServiceEstimate:
                url = SearchEstimate;
                break;
            case EModuleTypes.Jobcard:
                url = SearchJobCard;
                break;
            default:
                break;
        }
        return url;
    };
    var handleNavigation = function (value) {
        if (!value)
            return;
        var navigateArgs = {
            state: {
                fromRoute: window.location.pathname
            }
        };
        switch (value === null || value === void 0 ? void 0 : value.type) {
            case EModuleTypes.Appointment:
                navigate("/appointment-Detail/".concat(value === null || value === void 0 ? void 0 : value.id), navigateArgs);
                break;
            case EModuleTypes.Inspection:
                navigate("/inspection-Detail/".concat(value === null || value === void 0 ? void 0 : value.id), navigateArgs);
                break;
            case EModuleTypes.ServiceEstimate:
                if ([StatusEnum.Created, StatusEnum.Error, StatusEnum.Cancelled].includes(value === null || value === void 0 ? void 0 : value.StatusName))
                    navigate("/serviceEstimate-details-created/".concat(value === null || value === void 0 ? void 0 : value.id), navigateArgs);
                if ([StatusEnum.Converted, StatusEnum.Approved, StatusEnum.Closed].includes(value === null || value === void 0 ? void 0 : value.StatusName))
                    navigate("/serviceEstimate-details/".concat(value === null || value === void 0 ? void 0 : value.id), navigateArgs);
                break;
            case EModuleTypes.Jobcard:
                navigate("/jobcard-details/".concat(value === null || value === void 0 ? void 0 : value.id), navigateArgs);
                break;
            case EModuleTypes.FinalInspection:
                navigate("/jobcard-details/".concat(value === null || value === void 0 ? void 0 : value.id), navigateArgs);
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ React.createElement(FormSearchSelect, {
        key: clearKey,
        autoFocus: props.isSearchActive
        // sx={{ maxWidth: 400 }}
        ,
        id: "search",
        name: "search",
        placeholder: "Search by VIN, Reg No, Doc No",
        noOptionsText: "No records found",
        fullWidth: fullWidth,
        value: "",
        clearIcon: searchValue && (searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim()) !== "" ? /*#__PURE__*/ React.createElement(RoundClearIcon, {
            id: 'clearBtn',
            sx: {
                width: 18,
                height: 18
            },
            onClick: function () {
                setResponse([]);
                setsearchValue("");
                setClearKey(function (prevKey) { return prevKey + 1; });
            }
        }) : null,
        onChange: function (e, value) {
            handleNavigation(value);
        },
        onBlur: function () {
            setTimeout(function () {
                var input = document.getElementById('search');
                if (input && (!input.value || input.value.trim() === '')) {
                    setResponse([]);
                    setClearKey(function (prevKey) { return prevKey + 1; });
                }
            }, 100);
        },
        getOptionLabel: function (option) { return option === null || option === void 0 ? void 0 : option.RegistrationNo; },
        filterOptions: function (options) { return options; },
        valueExpr: "id",
        getListData: globalSearchAPICall,
        forcePopupIcon: false,
        slotProps: isMobile ? {
            paper: {
                sx: {
                    width: '100%',
                    borderRadius: '8px !important'
                }
            },
            popper: {
                anchorEl: document.getElementById('search'),
                sx: {
                    width: '100% !important',
                    px: 2,
                    borderRadius: '8px !important',
                    paddingTop: '8px !important'
                }
            }
        } : {},
        renderOption: function (props, option, state) {
            var _option$RegistrationN, _option$MobileNumber;
            var isLastOption = (state === null || state === void 0 ? void 0 : state.index) === (response === null || response === void 0 ? void 0 : response.length) - 1;
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MenuItem, _extends({}, props, {
                sx: {
                    m: 0,
                    p: 0
                }
            }), /*#__PURE__*/ React.createElement(MuiStack, {
                justifyContent: 'space-between',
                spacing: 1,
                width: '100%'
            }, /*#__PURE__*/ React.createElement(MuiStack, {
                direction: "column",
                alignItems: 'start',
                width: "60%",
                justifyContent: 'center',
                spacing: 0.5
            }, /*#__PURE__*/ React.createElement(Typography, {
                id: 'SerachResultRegNo',
                fontSize: "14px",
                sx: {
                    textWrap: 'pretty',
                    wordBreak: 'break-all',
                    fontWeight: "500"
                }
            }, (_option$RegistrationN = option === null || option === void 0 ? void 0 : option.RegistrationNo) !== null && _option$RegistrationN !== void 0 ? _option$RegistrationN : '-'), /*#__PURE__*/ React.createElement(MuiStack, {
                direction: "row",
                alignItems: 'flex-start',
                spacing: 1
            }, /*#__PURE__*/ React.createElement("img", {
                src: DocIcon,
                style: {
                    marginRight: "2px",
                    width: "16px",
                    height: "16px"
                }
            }), /*#__PURE__*/ React.createElement(Typography, {
                id: 'SerachResultDocNo',
                fontSize: "12px",
                color: "textSecondary",
                sx: {
                    textWrap: 'pretty',
                    wordBreak: 'break-all'
                }
            }, !(option !== null && option !== void 0 && option.SourceDocumentNo) ? option === null || option === void 0 ? void 0 : option.Code : option === null || option === void 0 ? void 0 : option.SourceDocumentNo)), moduleName === ModuleName.Dashboard && /*#__PURE__*/ React.createElement(Typography, {
                id: "serach-result-document-type",
                variant: "h4",
                color: systemColor.primary,
                sx: {
                    textWrap: 'pretty',
                    wordBreak: 'break-all',
                    textAlign: 'end'
                }
            }, option.type === "JobCard" ? "Job Card" : t(String(option.type)))), /*#__PURE__*/ React.createElement(MuiStack, {
                direction: "column",
                alignItems: 'end',
                width: "40%",
                spacing: 0.5
            }, /*#__PURE__*/ React.createElement(Typography, {
                id: 'SearchResultGivenName',
                fontSize: "14px",
                fontWeight: "400",
                sx: {
                    textWrap: 'pretty',
                    textAlign: 'end'
                }
            }, !(option !== null && option !== void 0 && option.GivenName) && !(option !== null && option !== void 0 && option.FamilyName) ? '-' : "".concat(option === null || option === void 0 ? void 0 : option.GivenName, " ").concat(option === null || option === void 0 ? void 0 : option.FamilyName)), /*#__PURE__*/ React.createElement(MuiStack, {
                direction: "row",
                alignItems: 'flex-start',
                spacing: 1
            }, /*#__PURE__*/ React.createElement(Typography, {
                id: 'searchResultMobileNo',
                fontSize: "12px",
                color: "textSecondary",
                sx: {
                    textWrap: 'pretty',
                    wordBreak: 'break-all',
                    textAlign: 'end'
                }
            }, (_option$MobileNumber = option === null || option === void 0 ? void 0 : option.MobileNumber) !== null && _option$MobileNumber !== void 0 ? _option$MobileNumber : "-"), /*#__PURE__*/ React.createElement("img", {
                id: "SearchResultCallIcon",
                src: PhoneGrayIcon,
                style: {
                    marginRight: "2px",
                    width: "16px",
                    height: "16px"
                }
            })), option.StatusName && /*#__PURE__*/ React.createElement(Chip, _extends({
                id: 'SearchResultStatus',
                sx: {
                    padding: '2px 8px',
                    borderRadius: '6px',
                    height: 'auto',
                    width: 'fit-content',
                    '& .MuiChip-label': {
                        display: 'block',
                        whiteSpace: 'normal'
                    },
                    fontSize: "12px"
                },
                label: (option === null || option === void 0 ? void 0 : option.StatusName) || '-',
                size: "small"
            }, getStatusColor(String(option === null || option === void 0 ? void 0 : option.StatusName) || '')))))), !isLastOption && /*#__PURE__*/ React.createElement(MuiStack, {
                display: "flex",
                justifyContent: "center"
            }, /*#__PURE__*/ React.createElement(Divider, {
                style: {
                    width: '95%'
                }
            })));
        },
        searchFilterPattern: /\s+/g
    });
};
export default DashboardSearch;
